import { render, staticRenderFns } from "./suspends.vue?vue&type=template&id=bba8ff72&"
import script from "./suspends.vue?vue&type=script&lang=js&"
export * from "./suspends.vue?vue&type=script&lang=js&"
import style0 from "./suspends.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bba8ff72')) {
      api.createRecord('bba8ff72', component.options)
    } else {
      api.reload('bba8ff72', component.options)
    }
    module.hot.accept("./suspends.vue?vue&type=template&id=bba8ff72&", function () {
      api.rerender('bba8ff72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/suspends.vue"
export default component.exports